import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UserService } from '@service/user/user.service';
import { FormGroup, NgForm } from '@angular/forms';
import { User } from '@model/user/user';
import { modelToFormGroup } from 'aautil';
import { messages } from '@configuration/messages';
import { ToastService } from '@service/toast/toast.service';
import { countries } from '@configuration/countries';
import { ConfirmDialogComponent } from '@modal/confirm-dialog/confirm-dialog.component';
import { ChangeMailDialogComponent } from '@modal/change-mail-dialog/change-mail-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ScrollService } from '@service/scroll.service';
import { ProfileStateComponent } from '../profile-state.component';
import { MobileService } from '@service/mobile.service';
import { ImageKeys } from '@type/image-keys';
import { StateService } from '@service/state.service';
import { SliderImagesService } from '@service/slider-images.service';

@Component({
  selector: 'app-profile-about',
  templateUrl: './profile-about.component.html',
  styleUrls: ['./profile-about.component.scss'],
})
export class ProfileAboutComponent extends ProfileStateComponent implements OnInit {
  public countries = countries;

  public messages = messages;

  public user: User;

  public form: FormGroup;

  // they dont need to be touched in this controller
  // they are manipulated from about-block-header
  public editNames: boolean = false;
  public editPersonal: boolean = false;
  public editSocial: boolean = false;
  public editAddress: boolean = false;
  public editCareer: boolean = false;
  public editAboutme: boolean = false;

  public edit: boolean = false;

  public loading: boolean = false;

  public userMinAge: number = 12;

  public submitted: boolean = false;

  @ViewChild('sliderInput1')
  public i1: ElementRef;

  public maxDate = new Date(
    new Date().getFullYear() - this.userMinAge,
    new Date().getMonth(),
    new Date().getDate(),
    12,
    0,
    0,
  );

  public hasSliderImages: boolean = false;

  constructor(
    private userService: UserService,
    private toastService: ToastService,
    private dialog: MatDialog,
    protected scrollService: ScrollService,
    public MobileService: MobileService,
    private StateService: StateService,
    public sliderImagesService: SliderImagesService,
  ) {
    super(scrollService);
  }

  public ngOnInit() {
    super.ngOnInit();

    this.userService.userObservable.subscribe((user) => {
      if (user) {
        this.user = user;
        this.form = modelToFormGroup(this.user);
      }
    });

    this.sliderImagesService.hasSliderImages$.subscribe((hasImages: boolean) => {
      this.hasSliderImages = hasImages;
    });

    this.sliderImagesService.checkHasSliderImages('profile');
  }

  public save(atts: string[]): Promise<void> {
    return new Promise((resolve, reject) => {
      this.loading = true;
      const updatedUserSettings: any = {};
      for (const att of atts) {
        updatedUserSettings[att] = this.form.controls[att].value;
      }

      this.userService
        .updateUser(updatedUserSettings)
        .then((user) => {
          this.cancel(atts);
          resolve();
        })
        .catch((err) => {
          console.error(err);
          this.toastService.showError('Leider ist ein Fehler beim Speichern des Benutzers aufgetreten.');
          reject();
        })
        .finally(() => {
          this.loading = false;
        });
    });
  }

  public cancel(atts: string[] = []): void {
    this.submitted = false;
    for (const att of atts) {
      this.form.controls[att].setValue(this.user[att]);
    }
  }

  public disableShowNickname(): void {
    if (this.form.value.private_nickname.length < 1) {
      this.form.value.use_nickname = false;
      this.user.use_nickname = false;
    }
  }

  public onLocationSelected($event: any) {
    this.onAutocompleteSelected($event);
  }

  public onAutocompleteSelected($event: any) {
    if (!$event.address_components) return;

    for (const cityDef of $event.address_components) {
      if (cityDef.types.includes('locality')) {
        this.form.controls.private_city.setValue(cityDef.long_name);
      }
      if (cityDef.types.includes('postal_code')) {
        this.form.controls.private_zip.setValue(cityDef.long_name);
      }
    }
  }

  public fileSelected(event: any, purpose: any): void {
    if (event.target.files && event.target.files[0]) {
      this.fileDropped(event.target.files, purpose);
    }
  }

  public fileDropped(filelist: any, purpose: ImageKeys) {
    this.loading = true;
    this.userService
      .onDropFile(filelist, purpose, this.user.id, true)
      .then((response: User) => {
        this.user.certificateImage = response.certificateImage;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public preview() {
    this.StateService.goto('/profileexternal/' + this.user.id);
  }

  public deleteCertificateImage(imageId: number, key: ImageKeys): Promise<void> {
    return new Promise((resolve, reject) => {
      const confirmConfig = {
        text: 'Wenn Du dein Zertifkat löschen willst, sende uns bitte eine Email an info@zimmerer-treff.com',
        buttons: [
          {
            text: 'OK',
            value: 'throw',
          },
        ],
      };
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: confirmConfig,
        disableClose: false,
        panelClass: ConfirmDialogComponent.cssClass,
      });

      resolve();
    });
  }

  public changeMailButtonClicked() {
    const dialogConfig = {};
    const dialogRef = this.dialog.open(ChangeMailDialogComponent, {
      data: dialogConfig,
      disableClose: false,
      panelClass: ChangeMailDialogComponent.cssClass,
    });
  }
}
